import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ModificationLog } from '../models/modification';

import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class ModificationLogService {
  private http = inject(HttpClient);
  configService = inject(ConfigService);

  getModificationLogs(id: string): Observable<ModificationLog[]> {
    return this.http.get<ModificationLog[]>(
      `${this.configService.getConfiguration().apiHost}/api/modificationlogs/${id}`
    );
  }
}
